import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, Card, ConfigProvider, Tag } from 'antd';
import { ReactComponent as TagCloseSvg } from '../../../assets/icons/tag-close.svg';
import { ReactComponent as TagCloseSvgLight } from '../../../assets/icons/tag-close-light.svg';
import { useTheme } from '../../../context/ThemeContext';
import { DARK } from '../../../utilities/constants';
const TaggedInput = ({
  dataSource,
  placeholder,
  onChange,
  tags,
  setTags,
  setTripData,
}) => {
  const { theme } = useTheme();
  const [inputValue, setInputValue] = useState('');
  const handleSearch = value => setInputValue(value);

  const handleSelect = value => {
    if (!tags.includes(value)) {
      setTripData(prev =>
        prev?.map(data =>
          data?.vehicle_number === value
            ? { ...data, checked: true }
            : { ...data }
        )
      );
      const newTags = [...tags, value];
      setTags(newTags);
      onChange(newTags);
    }
    setInputValue('');
  };

  const handleClose = removedTag => {
    setTripData(prev =>
      prev?.map(data =>
        data?.vehicle_number === removedTag?.vehicle_number
          ? { ...data, checked: false }
          : { ...data }
      )
    );
    const newTags = tags?.filter(tag => tag !== removedTag);
    setTags(newTags);
    onChange(newTags);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent any action on 'Enter' key
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            colorBgContainer: '#2E3033',
          },
          Select: {
            selectorBg: 'transparent',
            fontSize: '1rem',
            colorTextPlaceholder: 'var(--placeholder-text-color, #ffffff80)',
          },
          Tag: {
            defaultBg: 'var(--primary-fill-color, #1A1C1D)',
            colorBorder: 'var(--primary-fill-color, #1A1C1D)',
            defaultColor: 'var(--primary-text-color, #1A1C1D)',
            borderRadiusSM: 20,
            fontSize: '1rem',
          },
        },
      }}
    >
      <Card variant="borderless" className="full-height tagged-input-card">
        {tags?.map(tag => (
          <Tag
            className="tag-vehicle-number"
            data-cy={`tag-${tag?.vehicle_number}`}
            key={tag?.key}
            closable
            onClose={() => handleClose(tag)}
            color="default"
            closeIcon={
              theme === DARK ? (
                <TagCloseSvg
                  data-cy={`tag-close-icon-${tag?.vehicle_number}`}
                />
              ) : (
                <TagCloseSvgLight
                  data-cy={`tag-close-icon-${tag?.vehicle_number}`}
                />
              )
            }
          >
            {tag?.vehicle_number}
          </Tag>
        ))}
        <AutoComplete
          autoFocus
          data-cy="autocomplete-tags"
          style={{ width: 200 }}
          value={inputValue}
          options={dataSource
            .filter(
              dsItem =>
                !tags.some(
                  tagItem =>
                    tagItem.vehicle_number === dsItem.vehicle_number &&
                    tagItem.device_id === dsItem.device_id
                )
            )
            .map(option => ({ value: option?.vehicle_number }))}
          filterOption={(inputValue, option) =>
            option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={handleSelect}
          onSearch={handleSearch}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
        />
      </Card>
    </ConfigProvider>
  );
};

TaggedInput.propTypes = {
  dataSource: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tags: PropTypes.array,
  setTags: PropTypes.func.isRequired,
  setTripData: PropTypes.func.isRequired,
};

export default React.memo(TaggedInput);
